import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import EmailLoginForm from './EmailLoginForm';
import LoginWIthOtpForm from './LoginWIthOtpForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginMethodSwitcher from './LoginMethodSwitcher';
import { LoginFormProps } from '../../../shared/types';
import { useAuth } from '../../../../../contexts/AuthProvider';
import { useThemeMode } from '../../../../../contexts/ThemeProvider';

const LoginForm = ({ authLogic, config }: LoginFormProps) => {
  const { login } = useAuth();
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';

  const { loginMode, errors, isLoading, handleSubmit, LOGIN_MODES } = authLogic;

  const loginConfig = config?.login || {};

  const onSubmit = async (event: any) => {
    event.preventDefault();
    const result = await handleSubmit(event);

    if (result.success) {
      switch (result.type) {
        case 'login':
          const { user, accessToken } = result.data;

          const authUser = {
            id: user.id,
            email: user.email,
            phone: user.phone,
            name: user.name,
            role: user.role,
            status: 'active'
          };

          login(authUser, accessToken);
          break;

        case 'otp_sent':
          console.log('OTP sent successfully');
          break;

        case 'reset_sent':
          console.log('Reset email sent successfully');
          break;
      }
    }
  };

  return (
    <>
      <Box textAlign="center" mb={4}>
        {loginMode !== LOGIN_MODES.FORGOT_PASSWORD && (
          <Box textAlign="center" mb={4}>
            <Typography variant="h4" fontWeight="700" color={isDark ? '#ffffff' : '#1f2937'} mb={2}>
              {loginConfig.title || 'Welcome back'}
            </Typography>
            <Typography variant="body1" color={isDark ? 'rgba(255,255,255,0.7)' : '#6b7280'}>
              {loginConfig.subtitle || 'Sign in to access your learning dashboard'}
            </Typography>
          </Box>
        )}
      </Box>

      {errors.general && loginMode !== LOGIN_MODES.FORGOT_PASSWORD && (
        <Alert 
          severity="error" 
          sx={{ 
            mb: 3,
            backgroundColor: isDark ? 'rgba(244, 67, 54, 0.1)' : undefined,
            color: isDark ? '#ff6b6b' : undefined,
            '& .MuiAlert-icon': {
              color: isDark ? '#ff6b6b' : undefined
            }
          }}
        >
          {errors.general}
        </Alert>
      )}

      <Box component="form" onSubmit={onSubmit} autoComplete="on" noValidate>
        {loginMode === LOGIN_MODES.EMAIL && <EmailLoginForm authLogic={authLogic} config={config} />}

        {loginMode === LOGIN_MODES.EMAILWITHOTP && <LoginWIthOtpForm authLogic={authLogic} config={config} />}

        {loginMode === LOGIN_MODES.FORGOT_PASSWORD && <ForgotPasswordForm authLogic={authLogic} config={config} />}

        {loginMode !== LOGIN_MODES.FORGOT_PASSWORD && <LoginMethodSwitcher authLogic={authLogic} config={config} />}
      </Box>
    </>
  );
};

export default LoginForm;